var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center gap-8"},[(_vm.editable)?[_c('a-input',{model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}}),_c('a-icon',{attrs:{"type":"check"},on:{"click":_vm.check}})]:[_c('div',[_vm._v(_vm._s(_vm.value))]),_c('a-icon',{attrs:{"type":"edit"},on:{"click":_vm.edit}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }